import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { onLanguageChange } from '../i18n';

/**
 * Hook personalizzato che estende useTranslation per forzare il re-rendering 
 * quando cambia la lingua, utile per componenti che usano dati tradotti staticamente
 */
export const useTranslationReload = () => {
  const translation = useTranslation();
  const [_, setReloadFlag] = useState(0);

  useEffect(() => {
    // Registra un callback che incrementa il flag quando cambia la lingua,
    // forzando il re-rendering del componente
    const unsubscribe = onLanguageChange(() => {
      setReloadFlag(prev => prev + 1);
    });

    // Pulisci la sottoscrizione quando il componente viene smontato
    return () => {
      unsubscribe();
    };
  }, []);

  return translation;
};

export default useTranslationReload; 